<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="{ 'bg-primary navbar-dark': type === 'default' }"
  >
    <el-select
      name="empresa"
      v-model="plantaSelected"
      style="min-width: 400px"
      placeholder="Selecciona empresa..."
      filterable
    >
      <el-option
        v-if="showAllPlantsOption"
        key="all"
        value="all"
        label="TODAS LAS PLANTAS"
        class="all-plants-option"
      >
        <span class="all-plants-label">TODAS LAS PLANTAS</span>
      </el-option>
      <el-option
        v-for="empresa in available_empresas"
        :key="empresa.id"
        :value="empresa.id"
        :label="empresa.alias"
      >
      </el-option>
    </el-select>

    <!-- Search form -->
    <!-- <form
      class="navbar-search form-inline mr-sm-3"
      :class="{
        'navbar-search-light': type === 'default',
        'navbar-search-dark': type === 'light',
      }"
      id="navbar-search-main"
    >
      <div class="form-group mb-0">
        <div class="input-group input-group-alternative input-group-merge">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="fas fa-search"></i></span>
          </div>
          <input class="form-control" placeholder="Search" type="text" />
        </div>
      </div>
      <button
        type="button"
        class="close"
        data-action="search-close"
        data-target="#navbar-search-main"
        aria-label="Close"
      >
        <span aria-hidden="true">×</span>
      </button>
    </form> -->
    <!-- Navbar links -->
    <ul class="navbar-nav align-items-center ml-md-auto">
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div
          class="pr-3 sidenav-toggler"
          :class="{
            active: $sidebar.showSidebar,
            'sidenav-toggler-dark': type === 'default',
            'sidenav-toggler-light': type === 'light',
          }"
          @click="toggleSidebar"
        >
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
      <!-- <li class="nav-item d-sm-none">
        <a
          class="nav-link"
          href="#"
          data-action="search-show"
          data-target="#navbar-search-main"
        >
          <i class="ni ni-zoom-split-in"></i>
        </a>
      </li> -->

      <!--  <Language /> -->

      <base-dropdown
        class="nav-item"
        tag="li"
        title-classes="nav-link"
        title-tag="a"
        icon="ni ni-bell-55"
        menu-classes="dropdown-menu-xl dropdown-menu-right py-0 overflow-hidden"
      >
        <template>
          <!-- Dropdown header -->
          <div class="px-3 py-3">
            <h6 class="text-sm text-muted m-0">
              Tienes
              <strong class="text-primary">{{ totalNotif }}</strong>
              {{ totalNotif == 1 ? "mensaje" : "mensajes recibidos" }}
            </h6>
          </div>
          <!-- List group -->
          <div class="list-group list-group-flush">
            <a
              class="list-group-item list-group-item-action"
              v-for="notificacion in notificaciones"
              :key="notificacion.id"
            >
              <div class="row align-items-center">
                <div class="col-auto">
                  <!--  <img
                    alt="Image placeholder"
                    src="/img/theme/murrey.png"
                    class="avatar rounded-circle"
                  /> -->
                  <!--   <span
                    class="badge badge-default"
                    :style="[
                      notificacion.estado_notificacion.id == 1
                        ? { backgroundColor: 'orange' }
                        : { backgroundColor: 'green' },
                    ]"
                    >{{
                      notificacion.estado_notificacion.data.attributes
                        .descripcion
                    }}</span
                  > -->
                  <div
                    class="icon icon-shape text-dark rounded-circle shadow"
                    :style="[
                      notificacion.tipo_notificacion.data.attributes
                        .descripcion == 'revision'
                        ? { backgroundColor: '#b0eed3' }
                        : notificacion.tipo_notificacion.data.attributes
                            .descripcion == 'incidencia'
                        ? { backgroundColor: '#FD9D95' }
                        : { backgroundColor: '#b0eed3' },
                    ]"
                  >
                    <i
                      :class="[
                        notificacion.tipo_notificacion.data.attributes
                          .descripcion == 'revision'
                          ? 'ni ni-settings'
                          : notificacion.tipo_notificacion.data.attributes
                              .descripcion == 'incidencia'
                          ? 'ni ni-ambulance'
                          : 'ni ni-send',
                      ]"
                      :style="[
                        notificacion.tipo_notificacion.data.attributes
                          .descripcion == 'revision'
                          ? { color: '#1aae6' }
                          : notificacion.tipo_notificacion.data.attributes
                              .descripcion == 'sistema'
                          ? { color: '#03acca' }
                          : { color: '#BD0D00' },
                      ]"
                    ></i>
                  </div>
                </div>
                <div class="col ml--2">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="mt-3">
                      <h5 class="text-muted">
                        De:
                        {{ notificacion.usuario_origen.data.attributes.nombre }}
                        {{
                          notificacion.usuario_origen.data.attributes.apellidos
                        }}
                        ({{ moment(notificacion.createdAt).fromNow() }})
                      </h5>
                    </div>
                  </div>
                  <!--  MENSAJE DIRECTO -->
                  <div
                    v-if="
                      notificacion.tipo_notificacion.data.attributes
                        .descripcion == 'mensaje_directo'
                    "
                  >
                    <h5 class="mt-3 mb-0">{{ notificacion.descripcion }}</h5>
                    <br />
                  </div>

                  <!-- INCIDENCIA -->
                  <div
                    v-if="
                      notificacion.tipo_notificacion.data.attributes
                        .descripcion == 'incidencia'
                    "
                  >
                    <h5 class="mt-3 mb-0">{{ notificacion.descripcion }}</h5>
                    <br />
                    <h5 v-html="notificacion.activos"></h5>
                  </div>
                </div></div
            ></a>
          </div>
          <!-- View all -->
          <!--  <a
            href="#!"
            class="dropdown-item text-center text-primary font-weight-bold py-3"
            >Ver todas las notificaciones</a
          > -->
          <router-link
            to="/notificacion-management/list-notificaciones"
            class="dropdown-item text-center text-primary font-weight-bold py-3"
            >Ver todos los mensajes</router-link
          >
        </template>
      </base-dropdown>
      <!-- <base-dropdown
        menu-classes="dropdown-menu-lg dropdown-menu-dark bg-default dropdown-menu-right"
        class="nav-item"
        tag="li"
        title-tag="a"
        title-classes="nav-link"
        icon="ni ni-ungroup"
      >
        <template>
          <div class="row shortcuts px-4">
            <a href="#!" class="col-4 shortcut-item">
              <span
                class="shortcut-media avatar rounded-circle bg-gradient-red"
              >
                <i class="ni ni-calendar-grid-58"></i>
              </span>
              <small>Calendar</small>
            </a>
            <a href="#!" class="col-4 shortcut-item">
              <span
                class="shortcut-media avatar rounded-circle bg-gradient-orange"
              >
                <i class="ni ni-email-83"></i>
              </span>
              <small>Email</small>
            </a>
            <a href="#!" class="col-4 shortcut-item">
              <span
                class="shortcut-media avatar rounded-circle bg-gradient-info"
              >
                <i class="ni ni-credit-card"></i>
              </span>
              <small>Payments</small>
            </a>
            <a href="#!" class="col-4 shortcut-item">
              <span
                class="shortcut-media avatar rounded-circle bg-gradient-green"
              >
                <i class="ni ni-books"></i>
              </span>
              <small>Reports</small>
            </a>
            <a href="#!" class="col-4 shortcut-item">
              <span
                class="shortcut-media avatar rounded-circle bg-gradient-purple"
              >
                <i class="ni ni-pin-3"></i>
              </span>
              <small>Maps</small>
            </a>
            <a href="#!" class="col-4 shortcut-item">
              <span
                class="shortcut-media avatar rounded-circle bg-gradient-yellow"
              >
                <i class="ni ni-basket"></i>
              </span>
              <small>Shop</small>
            </a>
          </div>
        </template>
      </base-dropdown> -->
    </ul>
    <ul class="navbar-nav align-items-center ml-auto ml-md-0">
      <base-dropdown
        menu-on-right
        class="nav-item"
        tag="li"
        title-tag="a"
        title-classes="nav-link pr-0"
      >
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <div class="media align-items-center">
            <span
              class="avatar avatar-sm rounded-circle avatar-image"
              :style="{
                'background-image': `url('${profileImage}')`,
              }"
            >
            </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold">{{ title }}</span>
            </div>
          </div>
        </a>

        <template>
          <!--  <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">¡Bienvenido!</h6>
          </div> -->
          <a href="/user-profile" class="dropdown-item">
            <i class="ni ni-single-02"></i>
            <span>Perfil</span>
          </a>
          <div class="dropdown-divider"></div>
          <a @click.prevent="logout()" to="" class="dropdown-item">
            <i class="ni ni-user-run"></i>
            <span>Cerrar sesión</span>
          </a>
        </template>
      </base-dropdown>
    </ul>
  </base-nav>
</template>
<script>
import axios from "axios";
import { BaseNav } from "@/components";
import Language from "../Components/Language.vue";
import { cloneDeep } from "lodash";
import { Select, Option } from "element-ui";

export default {
  components: {
    BaseNav,
    //Language,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    type: {
      type: String,
      default: "default", // default|light
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)",
    },
  },
  watch: {
    plantaSelected: function (newVal, oldVal) {
      console.log("estic al watch");
      console.log(newVal);
      console.log(oldVal);
      if (newVal != oldVal) {
        localStorage.setItem("plantaSelected", newVal);
        // Limpiar estados de búsqueda al cambiar de planta
        localStorage.removeItem("activosSearchState");
        localStorage.removeItem("anclajeSearchState");
        localStorage.removeItem("episSearchState");
        localStorage.removeItem("herramientasSearchState");
      }

      if (oldVal != null) {
        console.log("ROUTER: ", this.$router);
        this.$router.push({ path: "/dashboard" });
        this.$router.go();
      }
    },
  },

  async created() {
    const url = process.env.VUE_APP_MEDIA_BASE_URL;
    await this.getProfile();
    console.log("USUARIO: ", this.user);

    this.title = this.user.nombre + " " + this.user.apellidos;
    // formats puede ser null (p.ej. imágenes sin variantes); no tumbar el bootstrap del navbar
    const perfilFormats = this.user.imagen_perfil && this.user.imagen_perfil.formats;
    if (perfilFormats && perfilFormats.thumbnail && perfilFormats.thumbnail.url) {
      this.avatar = perfilFormats.thumbnail.url;
    } else if (this.user.imagen_perfil && this.user.imagen_perfil.url) {
      this.avatar = this.user.imagen_perfil.url;
    }
    
    //comprobar si el usuario es usuario de salvador:
    const empresasUsuario = Array.isArray(this.user.empresas)
      ? this.user.empresas
      : [];
    const perteneceSalvador = empresasUsuario.some(
      (elemento) => elemento.id_cliente_erp === "00001001"
    );

    if (perteneceSalvador)
      this.available_empresas = await this.fetchAllEmpresas();
    else this.available_empresas = empresasUsuario;

    const primeraEmpresaId =
      this.available_empresas && this.available_empresas.length > 0
        ? this.available_empresas[0].id
        : null;

    console.log("planta localstorage....");
    console.log(localStorage.getItem("plantaSelected"));
    const plantaGuardada = localStorage.getItem("plantaSelected");
    
    if (plantaGuardada) {
      // 'all' solo aplica a Salvador; si no, caemos a la primera empresa del usuario
      if (plantaGuardada === 'all') {
        this.plantaSelected = perteneceSalvador ? 'all' : primeraEmpresaId;
      } else {
        const empresa = await this.buscarEmpresaPorId(
          plantaGuardada,
          perteneceSalvador
        );

        if (empresa) {
          console.log("Empresa encontrada:", empresa);
          this.plantaSelected = empresa.id;
          console.log("PASO POR AQUI COMO MOLOOOOO");
          // Elimina el estado guardado en localStorage
          localStorage.removeItem("activosSearchState");
          localStorage.removeItem("anclajeSearchState");
          localStorage.removeItem("episSearchState");
          localStorage.removeItem("herramientasSearchState");
        } else {
          console.log("No se encontró ninguna empresa con ese ID.");
          this.plantaSelected = perteneceSalvador ? 'all' : primeraEmpresaId;
        }
      }
    } else {
      // Si no hay planta guardada y el usuario es de Salvador, establecer 'all' por defecto
      this.plantaSelected = perteneceSalvador ? 'all' : primeraEmpresaId;
      if (this.plantaSelected != null) {
        localStorage.setItem("plantaSelected", this.plantaSelected);
      }
    }

    console.log("PLANTA SELECCIONADA: ");
    console.log(this.plantaSelected);
    let params = {
      filters: {
        usuario_destinos: {
          id: { $in: this.user.id },
        },
      },
    };
    await this.$store.dispatch("notificaciones/list", params).then(() => {
      var notif = this.$store.getters["notificaciones/list"];

      this.totalNotif = this.$store.getters["notificaciones/listTotal"];

      this.total = this.$store.getters["notificaciones/listTotal"];

      this.notificaciones = notif.slice(0, 5);

      console.log(this.notificaciones);
    });
    // await this.$store.dispatch("profile/me");
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    profileImage() {
      return this.avatar ? this.avatar : "/img/placeholder.png";
    },
    showAllPlantsOption() {
      // Mostrar la opción si el usuario pertenece a Salvador Seguridad
      return this.user && this.user.empresas && this.user.empresas.some(
        empresa => empresa.id_cliente_erp === "00001001"
      );
    }
  },
  data() {
    return {
      locales: ["es", "en"],
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
      title: "Profile",
      avatar: null,
      notificaciones: [],
      query: null,
      plantaSelected: null,
      available_empresas: [],
      totalNotif: 0,
      user: null,
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    async logout() {
      try {
        this.$store.dispatch("logout");
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, algo ha ido mal!! Inténtalo más tarde.",
        });
      }
    },
    async getProfile() {
      try {
        await this.$store.dispatch("profile/me");
        this.user = await { ...this.$store.getters["profile/me"] };
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Sesión caducada.",
        });
        this.logout();
      }
    },
    async fetchAllEmpresas() {
      try {
        const response = await axios.get(
          `https://misepis-api.delfromsoftware.com/api/empresas?sort=alias:asc&pagination[pageSize]=1000`
        );

        // Mapeamos para combinar attributes + id en cada elemento
        const empresas = response.data.data.map((item) => {
          return {
            id: item.id,
            ...item.attributes,
          };
        });

        return empresas; // Devuelve el array combinado
      } catch (error) {
        console.error("Error fetching empresas data:", error);
        return []; // Retorna un array vacío en caso de error
      }
    },

    async buscarEmpresaPorId(empresaId, perteneceSalvador) {
      try {
        console.log("PERTENECE A SALVADOR: ", perteneceSalvador);
        console.log("EMPRESA ID A BUSCAR: ", empresaId);

        let empresas = [];
        if (perteneceSalvador) {
          empresas = await this.fetchAllEmpresas();
        } else {
          empresas = this.user.empresas;
        }

        let empresaEncontrada = null;

        for (let index = 0; index < empresas.length; index++) {
          const empresa = empresas[index];
          if (empresa.id === parseInt(empresaId)) {
            empresaEncontrada = empresa;
          }
        }

        return empresaEncontrada;
      } catch (error) {
        console.error("Error buscando empresa por ID:", error);
        return null; // En caso de error, devolvemos null
      }
    },
  },
};
</script>

<style>
/* Add these styles at the end of the file */
.all-plants-option {
  padding: 0 20px !important;
  height: 34px !important;
  line-height: 34px !important;
  font-size: 1em !important;
  background-color: transparent !important;
}

.all-plants-option:hover {
  background-color: #f5f7fa !important;
}

.all-plants-option.selected {
  background-color: transparent !important;
  font-weight: normal !important;
}

.all-plants-label {
  color: #606266;
}

/* Sobrescribir estilos de Element UI para la opción seleccionada */
.el-select-dropdown__item.selected {
  background-color: transparent;
}

.el-select-dropdown__item.all-plants-option.selected {
  color: #606266 !important;
  font-weight: normal !important;
}

/* Style for the select when "TODAS LAS PLANTAS" is selected */
.el-select__input.is-focus + .el-select__tags .el-tag:first-child,
.el-select__tags .el-tag:first-child {
  background-color: transparent !important;
  color: #606266 !important;
  font-weight: normal !important;
  border-color: #dcdfe6 !important;
}
</style>
